import { get, post } from "../Services/http";
import { QUICK_ORDER_QUERY, QUICK_ORDER_RECEIVE, QUICK_ORDER_IS_LOADING, QUICK_ORDER_IS_AUTO_COMPLETE_LOADING, QUICK_ORDER_ERROR } from '../constants';

export const queryArticleNumber = (articleNumber) => (dispatch, getState) => {
    dispatch(onQuery({ articleNumber }))
    if(!articleNumber || articleNumber.trim() == "") {
        dispatch(receive(null))
        return
    }

    return post('/api/quickorder/articlenumber', { articleNumber })
        .then(response => response.json())
        .catch(err => dispatch(onError(err)))
}

export const queryName = name => async (dispatch, getState) => {
    dispatch(onQuery({ name }))
    if(!name || name.trim() == "") {
        dispatch(receive(null))
        return
    }

    return await post('/api/quickorder/name', { name })
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(err => dispatch(onError(err)))
}

export const onQuery = query => ({
    type: QUICK_ORDER_QUERY,
    payload: {
        query,
        isAutoCompleteLoading: query != ""
    }
})

export const receive = data => ({
    type: QUICK_ORDER_RECEIVE,
    payload: {
        queryResult: data,
        isLoading: false
    }
})

export const setIsLoading = loading => ({
    type: QUICK_ORDER_IS_LOADING,
    payload: {
        isLoading: loading
    }
})

export const onError = error => ({
    type: QUICK_ORDER_ERROR,
    payload: {
        error
    }
})